import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { IMedia, IProduct } from 'src/types';
import { MediaList } from '../media-list';
import { DetailsContainer, DetailsTitle } from './account-details.styled';
import { css } from '@emotion/css';
import { Box, Divider, Tooltip, Typography, TextField } from '@mui/material';
import { Link } from 'react-router-dom';
import { TitleText, ProductsWrapper, ProductItem } from './account-additional-styles.styled';
import { useStyles } from './style';
import { DEFAULT_LANGUAGE } from 'src/constants';
import { AIGeneratedBanner } from '../ai-generated-banner';
import { isHtmlEmpty } from 'src/utils/is-html-empty.util';
import { RichDescription } from '../rich-description';

interface IProps {
  description: string;
  media: IMedia[];
  allProducts: IProduct[];
}

export const AccountDetails = ({ description, media, allProducts }: IProps) => {
  const [t, i18n] = useTranslation();
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const filteredProducts = allProducts.filter(
    (product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    product.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (product?.gtin || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const hasMedia = Array.isArray(media) && media.length > 0;
  const hasDescription = !isHtmlEmpty(description);
  const hasProducts = Array.isArray(allProducts) && allProducts.length > 0;

  const showDetailsTitle = hasDescription || hasMedia;
  const showDividerDescMedia = hasDescription && hasMedia;
  const showDividerMediaProducts = hasMedia && hasProducts;

  return (
    <DetailsContainer id="index__components-account-details__detailscontainer__l48">
      {showDetailsTitle && <DetailsTitle id="index__components-account-details__detailstitle__l49" variant="subtitle1">{t('about-us-label')}</DetailsTitle>}

      {hasDescription && <RichDescription html={description} sx={{ mb: '20px' }} />}

      {showDividerDescMedia && <Divider id="index__components-account-details__divider__l53" sx={{ borderColor: 'rgba(0,0,0,0.08);' }} />}

      {hasMedia && <MediaList media={media} />}

      {showDividerMediaProducts && <Divider id="index__components-account-details__divider__l57" sx={{ borderColor: 'rgba(0,0,0,0.08);' }} />}

      {/* <ProductsList products={products} /> */}
      {hasProducts &&
      <>
          <div id="index__components-account-details__div__l62" className={TitleText}>{t('product-list-title')}</div>
          {allProducts.length > 1 &&
        <TextField id="index__components-account-details__textfield__l64"
        label={t('account-products-search-placeholder')}
        variant="outlined"
        value={searchTerm}
        onChange={handleSearchChange}
        sx={{ marginBottom: '20px', width: '50%', minWidth: '200px' }} />

        }
          <div id="index__components-account-details__div__l72" className={ProductsWrapper}>
            {filteredProducts.map((el) =>
          <Box id="index__components-account-details__box__l74"
          key={el.id}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '120px',
            alignItems: 'center',
            gap: '4px',
            position: 'relative'
          }}>
            
                {el?.ai_generated && <AIGeneratedBanner />}
                <Tooltip id="index__components-account-details__tooltip__l86" key={el.id} title={el.name} PopperProps={{ className: classes.popper }}>
                  <Link
                className={css(
                  ProductItem,
                  `background-image: url('${el.image_medium ?? el.image_small ?? el.image}');`
                )}
                to={
                i18n.language === DEFAULT_LANGUAGE ?
                `/${el.simple_id}` :
                `/${i18n.language}/${el.simple_id}`
                }>
              </Link>
                </Tooltip>
                <Typography id="index__components-account-details__typography__l99"
            sx={{ color: '#000', fontWeight: 600, textAlign: 'center', mt: '3px' }}
            variant="body2">
              
                  {el.name}
                </Typography>
                {el?.gtin &&
            <Typography id="index__components-account-details__typography__l106" sx={{ fontSize: '10px' }} variant="body2">
                    {el.gtin}
                  </Typography>
            }
              </Box>
          )}
          </div>
        </>
      }
    </DetailsContainer>);

};